const state = {
  show: false,
  keyAudio: "",
};

const mutations = {
  setShow(state, isShow) {
    state.show = isShow;
  },

  setKeyAudio(state, keyAudio) {
    state.keyAudio = keyAudio;
  },
};

const actions = {};

const getters = {
  show(state) {
    return state.show;
  },

  keyAudio(state) {
    return state.keyAudio;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
